import * as d3 from 'd3'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      d3: () => d3,
    },
  }
})
